/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, imageTypes } from 'utils/styles/style_helpers';
import { url } from 'utils/urls';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// TAB HEAD : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	tabhead: {
		background: theme.color.light.light.swatch,
		borderRadius: pxToEm(4),
		border: replacePXinStringWithEM(`1px solid #ECF0F7`),
		boxShadow: replacePXinStringWithEM(`0 1px 1px 0 #EDF1FA`),
		cursor: 'pointer',
		width: pxToEm(171),
		height: pxToEm(127),
		margin: replacePXinStringWithEM('0 20px 20px 0'),
		textAlign: 'center',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		position: 'relative',
		zIndex: '2',

		// tab children
		'& .tabtitle': {
			fontSize: pxToEm(14),
			'&:after': {
				extend: imageTypes.graphic,
				content: '" "',
				display: 'block',
				margin: replacePXinStringWithEM(`${pxToEm(10)} auto 0`),
				width: pxToEm(42),
				height: pxToEm(42)
			}
		},
		'& .tabdivider': {
			background: 'transparent',
			border: replacePXinStringWithEM(`1px solid transparent`),
			width: pxToEm(171),
			height: pxToEm(23),
			position: 'absolute',
			bottom: pxToEm(-21),
			left: pxToEm(-1)
		},

		// last tab
		'&:last-child': {
			marginRight: '0'
		},

		// unique tabs
		'&#websitecode': { '& .tabtitle': { '&:after': { backgroundImage: `url(${url.image.app}/mks/icon-code.png)` } } },
		'&#instantarticle': { '& .tabtitle': { '&:after': { backgroundImage: `url(${url.image.app}/mks/icon-facebook.png)` } } },
		'&#dfp': { '& .tabtitle': { '&:after': { backgroundImage: `url(${url.image.app}/mks/icon-dfp.png)` } } },
		'&#amp': { '& .tabtitle': { '&:after': { backgroundImage: `url(${url.image.app}/mks/icon-amp.png)` } } },
		'&#inapp': { '& .tabtitle': { '&:after': { backgroundImage: `url(${url.image.app}/mks/icon-inapp.png)` } } },

		// on states
		'&.on': {
			borderColor: theme.color.primary.light.swatch, 
			borderBottom: '0',
			'& .tabdivider': { background: theme.color.light.light.swatch, borderColor: theme.color.primary.light.swatch, borderTop: '0', borderBottom: '0' },
		}
	}
});